import { buildProductBadge } from './utils';
import QuickShopClass from '../../components/product-quickshop/product-quickshop.js';

export default () => ({
  dismissed: false,
  expanded: false,
  visible: false,
  useMiniCards: false,
  showConfirmation: false,
  buildProductBadge,
  buttonText: 'Learn More',
  themeColor: '#602379',
  themeColorForeground: '#5a5959',
  productCardBackground: '#f4f0f6',

  // GTM Event tracking helper
  fireGTMEvent(panelState) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'cross_sell_panel_state',
        feature: 'Cross-Sell Panel',
        panel_state: panelState,
      });
    }
  },

  init() {
    this.dismissed = localStorage.getItem('panelup-dismissed') === 'true';
    this.useMiniCards = this.$el.hasAttribute('data-use-mini-cards');
    this.buttonText = this.$el.dataset.buttonText;
    this.themeColor = getComputedStyle(this.$el).getPropertyValue('--theme-color').trim();
    this.themeColorForeground = getComputedStyle(this.$el).getPropertyValue('--theme-color-foreground').trim();
    this.productCardBackground = getComputedStyle(this.$el).getPropertyValue('--product-card-background').trim();

    const recommendationLimitForComplementary = this.$el.dataset.complementaryProductsLimit || 3;
    const panelUpDelay = parseInt(this.$el.dataset.panelUpDelay) || 3000;
    
    // Get current product ID from page
    const productId =
      document.querySelector('[data-product-id]')?.dataset?.productId;
    if (!productId) return;

    // Fetch products using store
    Alpine.store('xsell')
      .product
      .fetchRecommendedProducts(productId, parseInt(recommendationLimitForComplementary))
      .then(() => {
        if (!this.dismissed && Alpine.store('xsell').product.crossSellProducts.length) {
          Alpine.store('xsell').product.showPanelUp = true;
          setTimeout(() => {
            this.visible = true;
          }, panelUpDelay);
        }
      });

    // Watch for expanded state changes
    this.$watch('expanded', (value, oldValue) => {
      if (value !== oldValue && oldValue !== undefined) {
        if (value) {
          this.fireGTMEvent('Panel Expand');
        } else {
          this.fireGTMEvent('Panel Collapse');
        }
      }
    });

    // Watch for dismissed state changes
    this.$watch('dismissed', (value, oldValue) => {
      if (value !== oldValue && oldValue !== undefined && value === true) {
        this.fireGTMEvent('Panel Close');
      }
    });
  },

  dismiss() {
    this.dismissed = true;
    localStorage.setItem('panelup-dismissed', 'true');
  },

  initSwiper() {
    this.$nextTick(() => {
      const slider = new Swiper(this.$refs.productsSlider, {
        slidesPerView: this.useMiniCards ? 1 : 1.5,
        spaceBetween: 16,
        centeredSlides: true,
        navigation: {
          nextEl: '.panel-up .swiper-button-next',
          prevEl: '.panel-up .swiper-button-prev',
        },
        breakpoints: {
          768: { slidesPerView: 2, centeredSlides: false },
          992: { slidesPerView: 3, centeredSlides: false },
          1200: { slidesPerView: 4, centeredSlides: false },
        },
      });
      slider.init();
    });
  },

  buildProductBadge(product) {
    let html = '';
    const hasComparePrice = product.compare_at_price_min > product.price_min;

    // Sale price takes precedence
    if (hasComparePrice) {
      return `
        <span class="prod-card__banner-badge prod-card__banner-badge--sale">Sale</span>
        <span class="prod-card__banner-background prod-card__banner-background--sale"></span>
      `;
    }

    // Check for badge tags
    const badgeTag = product.tags.find(tag => tag.startsWith('badge:'));
    if (badgeTag) {
      const badgeType = badgeTag.split('badge:')[1].toLowerCase().replace(' ', '-');
      let badgeLabel = '';
      
      switch(badgeType) {
        case 'sale':
          badgeLabel = 'Sale';
          break;
        case 'best-seller':
          badgeLabel = 'Best Seller';
          break;
        case 'new':
          badgeLabel = 'New';
          break;
        case 'multi-buy':
          badgeLabel = 'Multi-Buy';
          break;
      }

      if (badgeLabel) {
        html = `
          <span class="prod-card__banner-badge prod-card__banner-badge--${badgeType}">${badgeLabel}</span>
          <span class="prod-card__banner-background prod-card__banner-background--${badgeType}"></span>
        `;
      }
    }

    return html;
  },

  openQuickshop(product) {
    const quickshop = QuickShopClass.getInstance();

    const quickshopConfig = {
      headerText: this.buttonText,
      themeClass: 'quickshop--panel-up-theme',
      themeColor: {
        theme: this.themeColor,
        foreground: this.themeColorForeground,
        background: this.productCardBackground,
      },
      source: 'cross-sell-panel',
    };

    // console.log( 'Opening quickshop from panelup:', quickshopConfig.headerText );
    this.expanded = false;
    quickshop.addToQuickshop(product.handle, false, null, quickshopConfig);
  },

  get products() {
    return Alpine.store('xsell').product.crossSellProducts;
  },
});
